<template>
  <div>
    <div class="mb-10 mt-20 Wrapper" style="max-width: 980px">
      <div class="OptionParent">
        <div
          v-for="(method, index) in paymentMethods"
          v-bind:key="index"
          @click="dispatch({ type: 'payment_btn', idx: index })"
          class="OptionWrapper"
          v-show="!method.hide"
        >
          <div
            class="Option border-b-2 flex flex-row items-center text-3xl cursor-pointer"
            v-bind:class="[method.active ? 'border-qwellow' : 'border-qwray']"
          >
            <div class="IconWrapper"><img :src="method.icon" /></div>
            <div class="font-bold Button">{{ $t(method.text) }}</div>
          </div>
        </div>
      </div>
      <div class="MethodsWrapper" style="max-width: 90%">
        <InApp :active="paymentMethods[0].active" :isMobile="isMobile" />
        <Contactless :active="paymentMethods[1].active" :isMobile="isMobile" />
        <ChargingCard
          :active="paymentMethods[2] && paymentMethods[2].active"
          :isMobile="isMobile"
        />
      </div>
    </div>
  </div>
</template>

<script>
import InApp from './InApp.vue';
import Contactless from './Contactless.vue';
import ChargingCard from './ChargingCard.vue';

export default {
  components: { InApp, Contactless, ChargingCard },
  props: ['paymentMethods', 'dispatch', 'isMobile'],
};
</script>

<style scoped>
.OptionParent {
  --options-padding: 0;
  --option-child-padding: 0;
  --option-child-margin: 0;
  --option-font-color: #2b4047;
  --grid-gap: 0;
  --option-max-width: auto;
  display: grid;
  /* justify-content: space-evenly; */
  width: 100%;
  /* padding: var(--options-padding); */ /* for desktop */
  padding: 0 0.5em; /* for mobile * /
  /* flex-direction: row; */
  grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
  gap: var(--grid-gap);
  color: var(--option-font-color);
}

.OptionParent > div:first-child > div {
  margin: 0;
}
.OptionWrapper {
  align-self: center;
  justify-self: center;
  width: 100%;
}
.Option {
  /* padding: 0 var(--option-child-padding); */
  /* margin-left: var(--option-child-margin); */
  display: flex;
  justify-content: center;
  max-width: var(--option-max-width);
}
.Wrapper {
  --btn-f-size: 14px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.MethodsWrapper {
  margin-top: 2em;
  margin-left: auto;
  margin-right: auto;
  width: 100%;
}
.Button {
  font-size: var(--btn-f-size);
}
.IconWrapper {
  display: none;
}
@media (min-width: 380px) {
  .OptionParent {
    --grid-gap: 1em;
    /* grid-template-columns: 1fr 1fr 1fr; */
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  }
}
@media (min-width: 768px) {
  .OptionParent {
    --options-padding: 0 1em;
    --option-child-padding: 1em;
    --option-child-margin: 2.5rem;
    --grid-gap: 4em;
  }

  .Wrapper {
    --btn-f-size: 14px;
  }
  .IconWrapper {
    display: block;
  }
  .Option .Button {
    margin-left: 5px;
  }
}

@media (min-width: 1024px) {
  .OptionParent {
    --grid-gap: 1em;
    --options-padding: 0 2em;
    padding: var(--options-padding);
    --option-max-width: 225px;
  }
  .Option .Button {
    margin-left: 10px;
  }
}
@media (min-width: 1300px) {
  .Wrapper {
    --btn-f-size: 18px;
  }
}

@media (min-width: 1600px) {
  .Wrapper {
    --btn-f-size: 20px;
  }
}
</style>
